import { call, put, takeLatest } from "redux-saga/effects";
import { traTienSinhVienApi } from "../../../api/bao-cao/traTienSinhVienApi";
import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import {
  ITraTienSinhVienDotFilterRequest,
  ITraTienSinhVienDotSaveRequest,
  ITraTienSinhVienExportRequest,
  ITraTienSinhVienKhoaRequest,
  ITraTienSinhVienSaveRequest,
  ITraTienSinhVienThietLapInRequest,
} from "../../../model/request/bao-cao/ITraTienSinhVienRequest";
import {
  ITraTienSinhVienChiTiet,
  ITraTienSinhVienDot,
  ITraTienSinhVienLog,
} from "../../../model/respone/bao-cao/ITraTienSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eTraTienSinhVienActionIds,
  ITraTienSinhVienActionTypes,
} from "../../action-types/bao-cao/ITraTienSinhVienActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.baoCao.traTienSinhVien;

export function* traTienSinhVienSaga(): any {
  yield takeLatest(eTraTienSinhVienActionIds.LOAD_DOT_START, loadDotWorker);
  yield takeLatest(eTraTienSinhVienActionIds.SAVE_DOT_START, saveDotWorker);
  yield takeLatest(eTraTienSinhVienActionIds.DELETE_DOT_START, deleteDotWorker);
  yield takeLatest(eTraTienSinhVienActionIds.KHOA_START, khoaWorker);
  yield takeLatest(
    eTraTienSinhVienActionIds.LUU_THIET_LAP_IN_START,
    luuThietLapInWorker,
  );
  yield takeLatest(
    eTraTienSinhVienActionIds.LOAD_CHI_TIET_START,
    loadChiTietWorker,
  );
  yield takeLatest(
    eTraTienSinhVienActionIds.SAVE_CHI_TIET_START,
    saveChiTietWorker,
  );
  yield takeLatest(eTraTienSinhVienActionIds.LOAD_LOG_START, loadLogWorker);
  yield takeLatest(eTraTienSinhVienActionIds.EXPORT_EXCEL_START, exportWorker);
  yield takeLatest(eTraTienSinhVienActionIds.XEM_TRUOC_START, xemTruocWorker);
}

function* loadDotWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.SelectDot,
    action.payload as ITraTienSinhVienDotFilterRequest,
  );
  if (res.is_success) {
    yield put(mainAction.LOAD_DOT_SUCCESS(res.data as ITraTienSinhVienDot[]));
  } else {
    yield put(mainAction.LOAD_DOT_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* saveDotWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.SaveDot,
    action.payload as ITraTienSinhVienDotSaveRequest,
  );
  if (res.is_success) {
    NotifyHelper.Success("Đã lưu đợt");
    yield put(mainAction.SAVE_DOT_SUCCESS(Number(res.data) || 0));
  } else {
    yield put(mainAction.SAVE_DOT_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* deleteDotWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.DeleteDot,
    action.payload as number,
  );
  if (res.is_success) {
    NotifyHelper.Success("Đã xoá đợt");
    yield put(mainAction.DELETE_DOT_SUCCESS(""));
  } else {
    yield put(mainAction.DELETE_DOT_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* khoaWorker(action: ITraTienSinhVienActionTypes): any {
  const request = action.payload as ITraTienSinhVienKhoaRequest;
  const res: IBaseRespone = yield call(traTienSinhVienApi.SetKhoa, request);
  if (res.is_success) {
    NotifyHelper.Success(request.is_khoa ? "Đã khoá đợt" : "Đã mở khoá đợt");
    yield put(mainAction.KHOA_SUCCESS(""));
  } else {
    yield put(mainAction.KHOA_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* luuThietLapInWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.LuuThietLapIn,
    action.payload as ITraTienSinhVienThietLapInRequest,
  );
  // Lưu NGẦM theo từng thay đổi nhỏ ở màn Thiết lập in — không báo thành công,
  // chỉ báo khi hỏng để người dùng biết thiết lập chưa được giữ lại.
  if (res.is_success) {
    yield put(mainAction.LUU_THIET_LAP_IN_SUCCESS(""));
  } else {
    yield put(mainAction.LUU_THIET_LAP_IN_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Không lưu được thiết lập in");
  }
}

function* loadChiTietWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.SelectChiTiet,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(
      mainAction.LOAD_CHI_TIET_SUCCESS(res.data as ITraTienSinhVienChiTiet[]),
    );
  } else {
    yield put(mainAction.LOAD_CHI_TIET_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* saveChiTietWorker(action: ITraTienSinhVienActionTypes): any {
  const request = action.payload as ITraTienSinhVienSaveRequest;
  const res: IBaseRespone = yield call(traTienSinhVienApi.SaveChiTiet, request);
  if (res.is_success) {
    NotifyHelper.Success(`Đã lưu ${Number(res.data) || 0} dòng`);
    yield put(mainAction.SAVE_CHI_TIET_SUCCESS(Number(res.data) || 0));
    // Nạp lại từ máy chủ để bảng ở bước 3 đúng bằng dữ liệu đã lưu.
    yield put(mainAction.LOAD_CHI_TIET_START(request.id_dot));
  } else {
    yield put(mainAction.SAVE_CHI_TIET_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* loadLogWorker(action: ITraTienSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    traTienSinhVienApi.SelectLog,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(mainAction.LOAD_LOG_SUCCESS(res.data as ITraTienSinhVienLog[]));
  } else {
    yield put(mainAction.LOAD_LOG_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* exportWorker(action: ITraTienSinhVienActionTypes): any {
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      traTienSinhVienApi.ExportExcel,
      action.payload as ITraTienSinhVienExportRequest,
    );
    if (res.is_success) {
      Download.Excel(
        res.data as string,
        `${fileNameWithTime(
          "Bang ke tra lai tien hoc phi",
          "Bảng kê trả lại tiền học phí",
        )}.xlsx`,
      );
      yield put(mainAction.EXPORT_EXCEL_SUCCESS(""));
    } else {
      yield put(mainAction.EXPORT_EXCEL_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    // finally: hỏng giữa chừng (mất mạng, hết phiên) cũng phải gỡ lớp phủ.
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* xemTruocWorker(action: ITraTienSinhVienActionTypes): any {
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      traTienSinhVienApi.XemTruoc,
      action.payload as ITraTienSinhVienExportRequest,
    );
    if (res.is_success) {
      yield put(mainAction.XEM_TRUOC_SUCCESS(res.data as string));
    } else {
      yield put(mainAction.XEM_TRUOC_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}
